const ORG_ID = {
  DigitalFuture: '81F1B5C22B94D9C0787E88DF3ECFA581',
} as const;

export const checkCustomerEnv = (env: keyof typeof ORG_ID, orgId: string) => {
  return ORG_ID[env] === orgId;
};
